export type ApiRequestOptions<T = unknown> = {
    readonly body?: any
    readonly cookies?: Record<string, unknown>
    readonly errors?: Record<number | string, string>
    readonly formData?: Record<string, unknown> | FormData
    readonly headers?: Record<string, unknown>
    readonly mediaType?: string
    readonly method:
      | "DELETE"
      | "GET"
      | "HEAD"
      | "OPTIONS"
      | "PATCH"
      | "POST"
      | "PUT"
    readonly path?: Record<string, unknown>
    readonly query?: Record<string, unknown>
    readonly responseHeader?: string
    readonly responseTransformer?: (data: unknown) => Promise<T>
    readonly url: string
  }

  export type ApiResult<TData = any> = {
    readonly body: TData
    readonly ok: boolean
    readonly status: number
    readonly statusText: string
    readonly url: string
  }
  

export class ApiError extends Error {
  public readonly url: string
  public readonly status: number
  public readonly statusText: string
  public readonly body: unknown
  public readonly request: ApiRequestOptions

  constructor(
    request: ApiRequestOptions,
    response: ApiResult,
    message: string,
  ) {
    super(message)

    this.name = "ApiError"
    this.url = response.url
    this.status = response.status
    this.statusText = response.statusText
    this.body = response.body
    this.request = request
  }
}

export interface APIKey {
  id: string
  name: string
  api_key: string
  user_id: string
  created_at: string
  updated_at: string
}

export interface APIKeyCreate {
  name: string
}